import React from 'react'
import MainLayout from '@layouts/main-layout'
import Careers from '@components/footer/careers'

const CareersPage = () => {
  return (
    <>
      <Careers />
    </>
  )
}

CareersPage.getLayout = (page: React.ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}

export default CareersPage
